export class InvoicePaymentTreasuryRequestDto {
  fromDate?: Date | null;
  toDate?: Date | null;
  origin: string;
  merchantId?: number | null;
  checkDaysBefore?: number | null;
}
